import LoadingIndicator from "src/components/LoadingIndicator";

export default function ParsingFile({ nRows }: { nRows: number }): JSX.Element {
  return (
    <LoadingIndicator
      message={`Validating (loaded ${nRows.toLocaleString()} rows)...`}
    />
  );
}
